import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { LetterEditor } from "@/components/letter-editor";
import { useEmrContext } from "@/hooks/emr-context";
import { useComposerStore } from "@/stores/composers";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { resolveLetterImages } from "@/utils/letter";
import { ComposerShell } from "./composer-shell";
/** Read-only letter viewer: resolves workspace image assets then renders the letter HTML. */
export function LetterViewerComposerBody(_ref) {
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    workspaceId = _useEmrContext.workspaceId;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var _useState = useState(composer.content),
    resolvedHtml = _useState[0],
    setResolvedHtml = _useState[1];
  useEffect(function () {
    if (!composer.content || !workspaceId) return;
    var active = true;
    resolveLetterImages(composer.content, workspaceId).then(function (html) {
      if (active) setResolvedHtml(html);
    });
    return function () {
      active = false;
    };
  }, [composer.content, workspaceId]);
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: composer.title,
    subtitle: composer.subtitle,
    wide: true,
    fullHeight: true,
    footer: /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-close-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CLOSE, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("close", {
      defaultValue: "Close"
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 flex-1 flex-col rounded-sds-200 border border-sds-base-default p-3"
  }, /*#__PURE__*/React.createElement(LetterEditor, {
    value: resolvedHtml,
    onChange: function onChange() {
      return undefined;
    },
    readOnly: true
  })));
}